'use client';

import { PageLoader } from '@/components/common';
import { getSettingsAction } from '@/server_actions/getSettings';
import { setSettings } from '@/store/settingsSlice';
import { Settings } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface SettingsProviderProps {
  children: React.ReactNode;
  settingsData: Settings;
}

export default function SettingsProvider({
  children,
  settingsData,
}: SettingsProviderProps) {
  const dispatch = useDispatch();
  const locale = useLocale();

  useEffect(() => {
    dispatch(setSettings(settingsData));
  }, []);

  return children;

  // const { data, isLoading } = useQuery({
  //   queryKey: ['settings', locale],
  //   queryFn: () => getSettingsAction(),
  //   staleTime: 1000 * 60 * 60 * 24,
  //   refetchOnMount: false,
  //   refetchOnWindowFocus: false,
  //   refetchOnReconnect: false,
  // });

  // const settings = data?.data || null;

  // useEffect(() => {
  //   if (!isLoading && settings) {
  //     dispatch(setSettings(settings));
  //   }
  // }, [isLoading, settings, dispatch]);

  // if (!settings) {
  //   return <PageLoader />;
  // }
}
